export default "__VITE_ASSET__mDOaM0$X__"